import { layoutPublicUrl, publicUrlapi } from './../../../constants/index';
import { observable, action, runInAction } from "mobx";
import { Dialog } from "@weapp/ui";
import * as API from "../../../api/createTeams";
import { TenantListType } from "./type";
import { getLabel } from "@weapp/utils";
import { getLocationOrigin } from "../../../utils";
import { privateKeyDecryption } from '../../../utils/encrypt';
const { message } = Dialog;

class CreateTeamsStore {
  @observable test: any = [];
  @observable applyInvite: any = [];
  @observable tenantList: TenantListType[] = [];
  @observable loading: boolean = false;
  @action
  init = () => {//TODO 调接口的时候按下边代码调就好
    // API.getAppModules().then((data: any) => {
    //   if (data && data.empmenus) {
    //     runInAction(() => {
    //       data.empmenus.forEach((menu: any) => {
    //         menu.menuStatus = Boolean(Number(menu.menuStatus));
    //       });
    //       this.apps = data.empmenus;
    //     });
    //   }

    //   console.log(data);
    // });
  };

  @action
  getList = (data: any) => {
    this.loading = true
    API.queryTenant(data)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.applyInvite = result.applyInvite;
            this.tenantList = result.tenantList;
            this.tenantList.splice(6);
            const privateKey = "MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAIQ6T9bLIkp0Ach8w4MWcqDswGitoUGcvcXXyGEvHmfTUnmDiEKSalzn4pAUohAgD9BaT2btAHMj85X1kMWTngtpabfE/wL4/VM+ntRUbPeI0Mt2+BLG4YRg+Ywvc1qqRtWW9bv82U0DcQPgpqjutHkZRhJ0V9toGjEEVp7rfyHNAgMBAAECgYAEmib3OeC6qKj7OmRvppNcyIC14/0t1G/CeA0wXLx5LqC7O/m9H212SFfZXe56EzOZs9r5oRwX5dNvj7l3NvkULctgKUhPyWgLEWFi5fwF9x7azCAwX0PLAMepoZ9XaC8Elknu2nlaFQhNQGeytRhsdqV7Du5Nx5MpmbLlJ9pQIQJBALjD5bs13SN1z1JRYhktXgevmp7IFulMv83qT7ZMd6TTtkiYgbtSScfB6kAEJDAvwBdwhKq8ruRrZJiulnMEsokCQQC3NQhlibqvRwqNo/IFf5PDs/+wdYLw+oghLp1oxOfJzp3eaThqIdRjtSD0lvIxbcPGBWXJdAmfv0bhcZ39wbQlAkEAsHt1yR9HDiLul9tij1f1M/Q5BadrswZ7Qu2nnCJoOcl7mNYLPOj5zlNcNC+AfYJuwjTYk9lMWKR33xsMW+rFuQJBAI1eBK6lCkJ55PDKktQfT1vxptj4tCNSjnxcReY0Gk8kebjHJFrw47xUZauWVihB9JD2VUaPnWWA6SbIzwqhz2kCQQCWBGk8IAo8m7wu1tF0w3Al77YeBIWntPDwhGx6fpJRmBhxzBlbsPZ1RaA7MODRRRrH5E62cqa4R9SPRw9/GDQ2"
            this.tenantList.forEach((item) => {
              item.realTenantKey = privateKeyDecryption(privateKey, item.tenantKey || "") || ""
            })
            this.loading = false;
          }
        });
      })
      .catch((error) => {
        // this.loading = false;
        console.log(error);
      });
  };
  @action
  createTeams = (data: any, callback?: any) => {
    if (data.areaCode) {
      data.adminMobile = data.areaCode + data.adminMobile;
    }
    API.createTeams(data)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            if (result.newEmpId) {
              window.location.href = (window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl) +
                publicUrlapi + '/papi/passport/changeTenantNew/' +
                result.newEmpId +
                `?ETEAMSID=${window.ETEAMSID}&service=${encodeURIComponent(getLocationOrigin() + layoutPublicUrl)}`
            } else {
              callback && callback();
              message({
                type: "error",
                content: result.message,
              });
            }
          }
        });
      })
      .catch((error) => {
        callback && callback();
        console.log(error);
      });
  };
  @action
  applyTenant = (data: any) => {
    this.loading = true
    API.applyTenant(data)
      .then((result: any) => {
        runInAction(() => {
          if (result && result.message) {
            message({
              type: "info",
              content: result.message,
            });
          } else {
            message({
              type: "info",
              content: getLabel('62279', '申请加入成功，请等待管理员确认！'),
            });
          }
          this.getList({ keywords: data.keywords });
        });
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  };

  @action
  recoverTenant = (data: any, callback?: Function) => {
    this.loading = true
    API.applyTenant(data)
      .then(() => {
        message({
          type: "success",
          content: getLabel('254889', '组织已成功恢复'),
        });
        this.getList({ keywords: data.keywords });
        callback?.();
      })
      .catch((error) => {
        console.log('recover tencent error: ', error);
        this.loading = false;
      });
  }

  @action
  cancleApply = (data: any) => {
    const { tenantKey, applyRecordId } = data
    API.cancleApply({ tenantKey, applyRecordId })
      .then((result: any) => {
        runInAction(() => {
          this.getList({ keywords: data.keywords });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

const instance = new CreateTeamsStore();

export default instance;
